import { signOut as firebaseSignOut } from 'firebase/auth';
import { firebaseAuth } from './firebase';
import { useAuth } from '@/contexts/AuthContext';
import { trackSignOut } from './analytics';

// Compatible interface with previous Better Auth useSession() calls.
export function useSession() {
  const { profile, isPending } = useAuth();
  return {
    data: profile ? { user: profile } : null,
    isPending,
  };
}

export async function signOut() {
  trackSignOut();
  return firebaseSignOut(firebaseAuth);
}
